import { Component, ViewChild, HostListener, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
// import { ScreenBuilderComponent } from '../screen-builder/screen-builder.component';
import { DataService } from '../../services/data.service';
import { User } from '../../models/user';
import { forEach } from '@angular/router/src/utils/collection';
//import { UserIdleService } from 'angular-user-idle';
import { SubscriptionService } from '../../services/subscription.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare var jquery: any;
declare var $: any;
let ng: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  isLoggedIn$: Observable<boolean>;
  public currentXmls: Array<any> = [];
  public currentScreens: Array<any> = [];
  public currentTemplates = { hdTemplate: [], fullHdTemplate: [], allTemplates: [], fullScreenWithImageTemplate: [], fullScreenWithVideoTemplate: [], menuTemplates: [] };
  public currentUser = { userRole: null };
  public currentUserObj: Observable<any>;
  public currentXmlsLoaded = false;
  public currentComponent = '/';
  public isUserIdle = false;
  public userIdleTime = 0;
  public count = 1;
  public mousein = false
  public gettingStartedTooltip = 'Getting Started Guide';
  public liveTVTooltip = 'Live TV';
  // public templateName1 ="";
  // public templateName2 ="";
  // public templatePath = "";
  // public imagePath = "";

  private modalRef;

  constructor(private authService: AuthService, private router: Router, private data: DataService,
    private subscriptionService: SubscriptionService, private modalService: NgbModal,
    // private userIdle: UserIdleService
  ) {
  }
  ngOnInit() {
    
    //   document.addEventListener('mousemove', function (this) {

    //     ng.resetUserIdleTime();
    //   });

    //   document.addEventListener('mousewheel', function (this) {
    //     ng.resetUserIdleTime();
    //   });

    //   document.addEventListener('click', function (this) {

    //     ng.resetUserIdleTime();
    //   });

    //   document.addEventListener('keypress', function (this) {
    //     ng.resetUserIdleTime();
    //   });

    //   document.addEventListener('mouseover', function() {
    //     ng.mousein = true;
    //     ng.reset();
    //  })

    ng = this;
    //this.checkUserIdleTime();

    this.isLoggedIn$ = this.authService.isLoggedIn;
    this.data.currentMessage.subscribe(message => {
      this.currentXmls = message;
      this.currentXmlsLoaded = true;
    });

    this.data.currentScreen.subscribe(message => {
      this.currentScreens = message;
    });

    this.data.currentTemplate.subscribe(message => {
      this.currentTemplates = message;
      // console.log(this.currentTemplates);
    });
    //dmb.screenlist.01
    // this.templateName1 = "dmb.screenlist.01.xml";
    // this.templateName2 = "dmb.screenlist.02.xml";
    // this.templatePath = 'templates\\All Templates\\Full Screen with Image\\screenshot.jpg';
    // this.imagePath = 'templates\\All Templates\\Full Screen with Image\\screenshot.png';
    // this.currentUser = this.authService.currentUser;
    this.authService.currentUserObj.subscribe(res => {
      // this.currentUserObj = this.authService.currentUserObj;
      // console.log(typeof res);
      if (res === 'string') {
        this.currentUser = JSON.parse(res);
        // console.log(res);
      } else {
        this.currentUser = res;
      }

      if (window.location.href.includes('scheduler')) {
        this.currentComponent = 'scheduler';
      }
    });
    // console.log(this.currentUserObj);
  }

  ngAfterViewInit(): void {
    $('[data-toggle="tooltip"]').tooltip({
      trigger: 'hover'
    });
  }

  onLogout(): void {
    this.resetCompleteScreen();
    this.authService.logout();
    //this.router.navigate(['/login']);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  openModel(content, config?: object, type?: string) {
    if (typeof config === 'undefined') {
      config = {};
    }
    this.modalRef = this.modalService.open(content, config);
  }

  closeModal(): void {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  @HostListener('window:scroll', ['$event'])
  public onWindowScroll(event: Event) {
    const scrollLeft = $(window).scrollLeft();
    $('#topNavBar').css('margin-left', scrollLeft + 'px');
  }
  @HostListener('document:click', ['$event'])
  public onClick(e: any): void {
    const className = e.target.className;
    if (className == 'modal videoModal') {
      $('#video1').trigger('pause');
      $('#video1').get(0).currentTime = 0;
      $('#video2').trigger('pause');
      $('#video2').get(0).currentTime = 0;
    }
  }
  openVideo1(): void {
    $('#video1').trigger('play');
  }
  openVideo2(): void {
    $('#video2').trigger('play');
  }
  openVideo3(): void {
    $('#video3').trigger('play');
  }
  closeVideo1(): void {
    //$("#video1").removeAttr("autoplay");
    $('#video1').trigger('pause');
    $('#video1').get(0).currentTime = 0;

  }
  closeVideo2(): void {
    //$("#video1").removeAttr("autoplay");
    $('#video2').trigger('pause');
    $('#video2').get(0).currentTime = 0;
  }
  closeVideo3(): void {
    //$("#video1").removeAttr("autoplay");
    $('#video3').trigger('pause');
    $('#video3').get(0).currentTime = 0;
  }
  resetCompleteScreen(): void {
    $('#resetCompleteScreenBtn').trigger('click');
  }
  openSettingsModal(): void {
    $('#openSettingsModalBtn').trigger('click');
  }
  preview_screenlist_file(): void {
    $('#preview_screenlist_file_btn').trigger('click');
  }
  save_screenlist(): void {
    $('#save_screenlist_btn').trigger('click');
  }
  preview_screenlist(): void {
    $('#preview_screenlist_btn').trigger('click');
  }
  publish_screenlist_file(): void {
    $('#publish_screenlist_file_btn').trigger('click');
  }
  sitelog_modal(): void {
    $('#siteLogsScreenBtn').trigger('click');
  }
  openPlayerRegistrationModal(): void {
    $('#openPlayerRegistrationModalBtn').trigger('click');
  }
  openEditPlayerModal(): void {
    $('#openEditPlayerModalBtn').trigger('click');
  }

  openEditScreenModal(): void {
    $('#openEditScreenModalBtn').trigger('click');
  }

  openPlayerStatusModal(): void {
    $('#openPlayerStatusModalBtn').trigger('click');
  }

  openTimeOfDayModal(): void {
    $('#openTimeOfDayModalBtn').trigger('click');
  }

  openSubscriptionsModal(): void {
    $('#openSubscriptionsModalBtn').trigger('click');
  }

  ep_preview_screenlist_file(): void {
    $('#ep_preview_screenlist_file_btn').trigger('click');
  }
  load_screenlist(fileName, templatePath, subDirectory: false, screenName: ''): void {
    this.data.openFile({ fileName: fileName, templatePath: templatePath, subDirectory: subDirectory, screenName: screenName });
  }
  getTemplateCount(str) {
    let res = false;
    // alert();
    if (str === 'fullHdTemplate' && typeof this.currentTemplates.fullHdTemplate !== 'undefined') {
      res = this.currentTemplates.fullHdTemplate.length > 0;
    } else if (str === 'hdTemplate' && typeof this.currentTemplates.hdTemplate !== 'undefined') {
      res = this.currentTemplates.hdTemplate.length > 0;
    } else if (str === 'fullScreenWithImageTemplate' && typeof this.currentTemplates.fullScreenWithImageTemplate !== 'undefined') {
      res = this.currentTemplates.fullScreenWithImageTemplate.length > 0;
    } else if (str === 'fullScreenWithVideoTemplate' && typeof this.currentTemplates.fullScreenWithVideoTemplate !== 'undefined') {
      res = this.currentTemplates.fullScreenWithVideoTemplate.length > 0;
    } else if (str === 'allTemplates' && typeof this.currentTemplates.allTemplates !== 'undefined') {
      res = this.currentTemplates.allTemplates.length > 0;
    }
    else if (str === 'menuTemplates' && typeof this.currentTemplates.menuTemplates !== 'undefined') {
      res = this.currentTemplates.menuTemplates.length > 0;
    }
    return res;
  }

  routeToComponent(component) {
    this.currentComponent = component;

    if (component === '/') {
      this.router.navigate([component]);
      setTimeout(() => {
        location.reload();
      }, 500);
    } else {
      this.router.navigate([component]);
    }
  }

  // checkUserIdleTime() {
  //   alert('idle');
  //   debugger;
  //     setInterval(function() { 
  //       ng.userIdleTime++;
  //       $("#userIdleTime").val(ng.userIdleTime);
  //       //check after 5 minutes
  //       if(ng.userIdleTime >= 300) {
  //         ng.onLogout();
  //       }
  //     }, 1000);
  // }

  // resetUserIdleTime() {
  //   debugger;
  //   this.userIdleTime = 0;
  // }

  demo() {
    if (this.mousein) return
    document.getElementById('demo1')
      .classList.toggle('hover')

  }

  reset() {
    this.count = 1
    var hovers = document.querySelectorAll('.hover')
    for (var i = 0; i < hovers.length; i++) {
      hovers[i].classList.remove('hover')
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts